var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{touchDown: _vm.touchDown},attrs:{"oncontextmenu":"return false;"},on:{"touchstart":_vm.TouchStart,"touchend":_vm.TouchEnd}},[_c('div',[_vm._v(_vm._s(_vm.button.label))]),(_vm.button.icon)?_c('d-icon',{attrs:{"icon":_vm.button.icon,"size":"is-small"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }